// extracted by mini-css-extract-plugin
module.exports = {"barcodeSvg":"Barcode_barcodeSvg___X1KO"};